import { Project } from '../../../../domain/projects/project';
import NumberField from '../../../shared/components/forms/NumberField';
import TextAreaField from '../../../shared/components/forms/TextAreaField';

interface Props {
    project: Project;
    isNewProject: boolean;
    onChange: (
        name: string,
        value: string | boolean | number[] | number | undefined
    ) => void;
}

export default function FinancialInformationSection({
    project,
    isNewProject,
    onChange: handleInputChange,
}: Props) {
    return (
        <>
            <h5 className='my-3'>Información Adicional</h5>

            <div className='col-6'>
                <TextAreaField
                    name='summary'
                    value={project.summary}
                    label='Información del proyecto'
                    required={false}
                    onChange={handleInputChange}
                    key='summary'
                    rows={10}
                />
            </div>
            <div className='col-6'>
                <NumberField
                    label='Costo Total'
                    name='totalCost'
                    onChange={handleInputChange}
                    required={true}
                    value={project.totalCost}
                    key='totalCost'
                />
            </div>
        </>
    );
}
